export default "__VITE_ASSET__DUoDj$hb__"